import { GenericModel } from "../../../generic.model";

export class VehicleModel extends GenericModel {
    public category: string;
    public code: string;
    public doorsQuantity: number;
    public luggageCapacity: number;
    public xAirConditioning: string;
    public xDrive: string;
    public xFuel: string;
    public xId: string;
    public xSize: string;
    public xTransmission: string;
    public xType: string;
    public name: string;
    public occupancy: number;
    public media: string;

    // TODO productArray: [{xRef: "SP.10"}]
    // TODO travellerArray: [{xRef: "T.1", index: 1}]
    // TODO vehicleRentalArray: [{xRef: "SVH.1"}]

    protected fromJson(json?: any): boolean {
    this.category = json.category ?? null;
    this.code = json.code ?? null;
    this.doorsQuantity = json.doorsQuantity ?? null;
    this.luggageCapacity = json.luggageCapacity ?? null;
    this.xAirConditioning = json.xAirConditioning ?? null;
    this.xDrive = json.xDrive ?? null;
    this.xFuel = json.xFuel ?? null;
    this.xId = json.xId ?? null;
    this.xSize = json.xSize ?? null;
    this.xTransmission = json.xTransmission ?? null;
    this.xType = json.xType ?? null;
    this.name = json.name?.value ?? null;
    this.occupancy = json.occupancy?.person?.quantity ?? null;
    this.media = json.mediaArray[0]?.imageArray[0]?.url ?? null;
    return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }

}